export default __webpack_public_path__ + "static/media/right.d8dec859.svg";